export default __webpack_public_path__ + "static/media/fasting_water@3x.3e983c91.jpg";